import { render } from "./photo-12.vue?vue&type=template&id=6fea2b7a&scoped=true"
import script from "./photo-12.vue?vue&type=script&lang=js"
export * from "./photo-12.vue?vue&type=script&lang=js"

import "./photo-12.vue?vue&type=style&index=0&id=6fea2b7a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fea2b7a"]])

export default __exports__